import React, { Component } from "react";
import { POST, alert, loading, t } from "../../../components/CustomComponent.js";
import { withRouter } from "../../../components/withRouter.js";
import Logo from "../../../components/Logo.js";
import Language from "../../../components/Language.js";
import ICON from "../icons.js";
import { NAV_LINKS, goSection, openPartner, openPartnerForgot } from "../options.js";
import { favCount, favSubscribe } from "../fav_store.js";
import { loadPost } from "../../../services/home_post.service.js";
import HomeLoginModal from "./HomeLoginModal.js";
import HomeProfileModal from "./HomeProfileModal.js";
import { getProfile } from "../../../utils/localStorage.js";
import { initials } from "../../../components/people_option.js";
// ให้แน่ใจว่า global.hasModuleAccess / global.menu_admin ถูกประกาศแล้ว (import ซ้ำได้)
import "../../../components/global.js";
import "../../../assets/css/home_login.css";

/* ============================================================================
 * HomeNavbar — แถบเมนูด้านบนของหน้าเว็บสาธารณะ
 * - ติดหัวจอ (sticky) และเพิ่มเงาเมื่อเลื่อนลง เพื่อแยกชั้นจากเนื้อหา
 * - ด้านขวาเรียงตามลำดับความสำคัญ : รายการโปรด › เข้าสู่ระบบ (หรือชื่อผู้ใช้เมื่อ
 *   ล็อกอินอยู่แล้ว — พาร์ตเนอร์ที่ได้รับอนุมัติจะกลับมาที่เว็บสาธารณะหน้านี้หลังล็อกอิน
 *   จึงต้องมีที่บอกว่า "เข้าระบบอยู่ในชื่อใคร" และทางออกจากระบบ ไม่งั้นปุ่มจะยังชวนให้
 *   เข้าสู่ระบบซ้ำทั้งที่เข้าอยู่แล้ว)
 *   ปุ่มเข้าสู่ระบบเปิดกล่อง HomeLoginModal แทนการพาไปหน้า /login เพื่อไม่ให้คนที่
 *   กำลังไล่ดูทรัพย์อยู่เสียตำแหน่งที่เลื่อนค้างไว้ และทางไป "สมัครเป็นพาร์ตเนอร์"
 *   ย้ายเข้าไปอยู่ท้ายกล่องนั้นแล้ว (คนที่กดเข้าสู่ระบบแล้วยังไม่มีบัญชีคือกลุ่ม
 *   เป้าหมายของใบสมัครพอดี) แถบเมนูจึงเหลือปุ่มหลักปุ่มเดียว ไม่แย่งสายตากันเอง
 * - จอเล็กยุบเป็นเมนูแบบพับ (burger)
 *
 * ครอบด้วย withRouter เพื่อให้ปุ่มสมัครพาร์ตเนอร์ในกล่องเข้าสู่ระบบเปลี่ยนหน้าแบบ
 * client-side ได้
 * (ดู openPartner ใน options.js — เปลี่ยนหน้าด้วย window.location จะโหลดบันเดิลใหม่
 * ทั้งก้อนจนหน้าจอขาวค้าง) ตัวห่อไม่รับ prop เพิ่ม หน้าที่วางเมนูอยู่แล้วจึงไม่ต้องแก้
 *
 * ตัวเลขบนปุ่มรายการโปรดอ่านจาก fav_store เองและฟังการเปลี่ยนแปลงตลอดเวลา
 * ไม่ได้รับมาเป็น prop — ทุกหน้าที่วางเมนูนี้จึงโชว์ตัวเลขตรงกันเสมอโดยไม่ต้อง
 * ถือ state ของตัวเอง และอัปเดตทันทีแม้ผู้ใช้ไปลบทิ้งที่แท็บอื่น
 * ========================================================================== */
class HomeNavbar extends Component {
  /* โปรไฟล์อ่านจาก localStorage ตอนสร้างคอมโพเนนต์ — หน้าเว็บสาธารณะไม่ได้ยิง
     ขอโปรไฟล์เองทุกครั้ง (คนส่วนใหญ่ที่เข้ามาดูทรัพย์ไม่ได้ล็อกอิน จะเสียคำขอฟรี)
     ค่านี้ถูกเขียนตอนล็อกอินสำเร็จแล้วโหลดหน้าใหม่ จึงตรงกับความจริงเสมอ */
  state = {
    stuck: false,
    open: false,
    active: "home",
    favorites: favCount(),
    login: false,
    profile: getProfile(),
    menu: false,
    // โปรไฟล์ของฉัน — พาร์ตเนอร์เข้าหลังบ้านไม่ได้ จึงต้องมีที่แก้ข้อมูลตัวเองตรงนี้
    account: false,
  };

  componentDidMount() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    // คลิกที่ใดก็ได้นอกเมนูผู้ใช้แล้วต้องปิด — ไม่งั้นเมนูจะค้างทับเนื้อหาจนกว่าจะกดปุ่มเดิมซ้ำ
    document.addEventListener("click", this.onDocClick);
    this.unsubscribeFav = favSubscribe(() => this.setState({ favorites: favCount() }));
    /* ปุ่มลงประกาศฟรีอยู่บนเมนูของทุกหน้าสาธารณะ โหลดปลายทางไว้ล่วงหน้าตั้งแต่เปิดหน้า
       กดแล้วจะได้ไม่ต้องรอ API ก่อนเด้งคำถามยืนยัน (service กันยิงซ้ำให้แล้ว) */
    loadPost();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    document.removeEventListener("click", this.onDocClick);
    this.unsubscribeFav();
  }

  userRef = React.createRef();

  onDocClick = (event) => {
    if (!this.state.menu) return;
    if (this.userRef.current?.contains(event.target)) return;
    this.setState({ menu: false });
  };

  onScroll = () => {
    const stuck = window.scrollY > 8;
    if (stuck !== this.state.stuck) this.setState({ stuck });
  };

  /* หน้าอื่นที่ไม่ใช่หน้าแรก (เช่น หน้ารายละเอียดทรัพย์) ไม่มีส่วนที่เมนูชี้ไป
     goSection จึงพากลับหน้าแรกแล้วค่อยเลื่อนไปยังส่วนนั้น แทนที่จะเลื่อนขึ้นบนเฉย ๆ
     (ลิงก์ในฟุตเตอร์ใช้ตัวเดียวกัน — กดจากบนหรือล่างต้องไปที่เดียวกัน) */
  go = (event, item) => {
    event.preventDefault();
    this.setState({ active: item.key, open: false });
    goSection(item.href);
  };

  /* กดรายการโปรด = เปิดหน้ารายการโปรดเป็นแท็บใหม่ ชุดเดียวกับการ์ดทรัพย์และปุ่ม
     "ดูทั้งหมด" — ผู้ใช้ที่กำลังไล่ดูทรัพย์อยู่จะได้ไม่เสียตำแหน่งที่เลื่อนค้างไว้
     หน้าที่อยากคุมเอง (เช่นหน้ารายการโปรดเอง) ส่ง onFavorite มาทับได้ */
  openFavorites = () => window.open("/favorites", "_blank", "noopener,noreferrer");

  /* เปิดกล่องเข้าสู่ระบบ — ปิดเมนูพับไปด้วย ไม่งั้นบนมือถือเมนูจะค้างอยู่ใต้กล่อง */
  openLogin = () => this.setState({ login: true, open: false });
  closeLogin = () => this.setState({ login: false });

  /* ปุ่ม "ไปหลังบ้าน" โผล่เฉพาะบัญชีที่มีสิทธิ์เมนูหลังบ้านจริง ถ้าโชว์ให้ทุกคนจะกดแล้ว
     โดน PermissionRoute เด้งไปหน้า not found

     พาร์ตเนอร์เข้าได้แล้ว (แดชบอร์ด · ทรัพย์ · การตลาด · ลูกค้า · นัดหมาย · รายงาน)
     ปุ่มนี้จึงเป็นทางเข้าหลังบ้านของพาร์ตเนอร์ที่ล็อกอินจากหน้าเว็บสาธารณะ — กล่อง
     เข้าสู่ระบบตรงนี้ตั้งใจให้อยู่หน้าเดิมหลังล็อกอิน ไม่ได้เด้งเข้าหลังบ้านให้เอง */
  adminLink = () => {
    const { profile } = this.state;
    if (!profile) return "";
    if (profile.user_type === "super_user") return "/ad/dashboard";
    return global.getFirstAccessibleLink(global.menu_admin, profile.role?.permission) || "";
  };

  Logout = async () => {
    this.setState({ menu: false, open: false });

    if (!(await alert("", "warning", t("confirm"), t("logout_ask"), t("logout"), t("cancel")))) return;

    loading(true);
    /* ยกเลิก token ฝั่ง server ก่อน — เรียกไม่สำเร็จ (เช่น token หมดอายุไปแล้ว)
       ก็ยังต้องล้างฝั่ง client ต่อ ไม่งั้นผู้ใช้จะค้างอยู่ในระบบ (สูตรเดียวกับ NavbarAdmin) */
    await POST("auth/logout");
    loading(false);

    /* ล้างเฉพาะกุญแจของการล็อกอิน ไม่ใช้ localStorage.clear() เหมือนหลังบ้าน —
       ที่นี่เป็นเว็บสาธารณะ ผู้ใช้มีรายการโปรดกับภาษาที่เลือกไว้เก็บอยู่ด้วย
       การออกจากระบบไม่ควรลบของพวกนั้นทิ้งไปด้วย */
    localStorage.removeItem("mn-acc-tk");
    localStorage.removeItem("mn-profile");
    window.location.reload();
  };

  render() {
    const { stuck, open, active, favorites, login, profile, menu, account } = this.state;
    const adminLink = this.adminLink();
    const { onPost } = this.props;
    const onFavorite = this.props.onFavorite || this.openFavorites;
    // ทุกหน้าที่วางเมนูนี้ได้ปุ่มสมัครพาร์ตเนอร์เหมือนกันโดยไม่ต้องส่ง prop มา
    const onPartner = this.props.onPartner || (() => openPartner(this.props.router.navigate));
    const onForgot = () => openPartnerForgot(this.props.router.navigate);

    return (
      /* กล่องเข้าสู่ระบบต้องอยู่ "นอก" <header> — .hm-nav เป็น sticky + z-index 1030
         จึงสร้าง stacking context ของตัวเอง ถ้าวางกล่องไว้ข้างใน z-index ของกล่อง
         จะถูกขังอยู่ในชั้นนั้น แล้วโดนอย่างอื่นที่ชั้นสูงกว่าบังได้ */
      <>
      <header className={`hm-nav ${stuck ? "is-stuck" : ""}`} id="hm-top">
        <div className="hm-container">
          <div className="hm-nav__inner">
            <a href="/" className="hm-nav__brand" aria-label="SafeSpace Life Living">
              <Logo size={40} />
            </a>

            <nav className="hm-nav__links">
              {NAV_LINKS.map((item) => (
                <a
                  key={item.key}
                  href={item.href}
                  className={`hm-nav__link ${active === item.key ? "is-active" : ""}`}
                  onClick={(e) => this.go(e, item)}
                >
                  {t(item.label)}
                </a>
              ))}
            </nav>

            <div className="hm-nav__right">
              <div className="d-none d-xxl-block">
                <Language />
              </div>
              {/* เหลือแค่ไอคอน — ชื่อปุ่มย้ายไปอยู่ที่ title/aria-label แทน
                  เพื่อให้ยังชี้เมาส์อ่านได้และโปรแกรมอ่านหน้าจอยังเรียกชื่อปุ่มถูก */}
              <button
                type="button"
                className="hm-nav__action"
                title={t("home_favorites")}
                aria-label={t("home_favorites")}
                onClick={onFavorite}
              >
                <span className="hm-ico">{ICON.heart}</span>
                {favorites > 0 && <span className="hm-nav__badge">{favorites}</span>}
              </button>
              {profile ? (
                /* ล็อกอินอยู่ : ชื่อผู้ใช้ + เมนูย่อย แทนที่ปุ่มเข้าสู่ระบบ */
                <div className="hm-nav__user" ref={this.userRef}>
                  <button
                    type="button"
                    className="hm-nav__user-btn"
                    aria-expanded={menu}
                    onClick={() => this.setState({ menu: !menu })}
                  >
                    <span className="hm-nav__user-avatar">{initials(profile.full_name || profile.email)}</span>
                    <span className="hm-nav__user-name">{profile.full_name || profile.email}</span>
                    <span className="hm-ico">{ICON.chevron_down}</span>
                  </button>

                  {menu && (
                    <div className="hm-nav__user-menu">
                      <div className="hm-nav__user-head">
                        <b>{profile.full_name || "-"}</b>
                        <span>{profile.email}</span>
                      </div>
                      <button
                        type="button"
                        className="hm-nav__user-item"
                        onClick={() => this.setState({ menu: false, account: true })}
                      >
                        <span className="hm-ico">{ICON.user}</span>
                        {t("partner_profile_title")}
                      </button>
                      {!!adminLink && (
                        <a className="hm-nav__user-item" href={adminLink}>
                          <span className="hm-ico">{ICON.grid}</span>
                          {t("home_go_admin")}
                        </a>
                      )}
                      <button type="button" className="hm-nav__user-item" onClick={this.Logout}>
                        <span className="hm-ico">{ICON.logout}</span>
                        {t("logout")}
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <button type="button" className="hm-btn hm-btn--primary hm-btn--sm hm-nav__login" onClick={this.openLogin}>
                  <span className="hm-ico">{ICON.user}</span>
                  <span>{t("sign_in")}</span>
                </button>
              )}
              {/* <button type="button" className="hm-btn hm-btn--primary hm-btn--sm hm-nav__cta" onClick={onPost}>
                {t("home_promo_post_cta")}
              </button> */}
              <button
                type="button"
                className="hm-nav__burger"
                aria-label="menu"
                aria-expanded={open}
                onClick={() => this.setState({ open: !open })}
              >
                <span className="hm-ico">{open ? ICON.close : ICON.bars}</span>
              </button>
            </div>
          </div>

          {/* เมนูสำหรับจอเล็ก */}
          <div className={`hm-nav__mobile ${open ? "is-open" : ""}`}>
            {NAV_LINKS.map((item) => (
              <a
                key={item.key}
                href={item.href}
                className={`hm-nav__mobile-link ${active === item.key ? "is-active" : ""}`}
                onClick={(e) => this.go(e, item)}
              >
                {t(item.label)}
                <span className="hm-ico">{ICON.chevron_right}</span>
              </a>
            ))}
            <div className="hm-nav__mobile-actions">
              <button type="button" className="hm-btn hm-btn--ghost" onClick={onFavorite}>
                <span className="hm-ico">{ICON.heart}</span>
                {t("home_favorites")}
              </button>
              {/* <button type="button" className="hm-btn hm-btn--primary" onClick={onPost}>
                <span className="hm-ico">{ICON.bullhorn}</span>
                {t("home_promo_post_cta")}
              </button> */}
            </div>
            {/* ปุ่มเข้าสู่ระบบเต็มบรรทัด — จอเล็กวางหลายปุ่มเรียงกันแล้วตัวอักษรจะถูกบีบจนอ่านไม่ออก
                ล็อกอินอยู่แล้วเปลี่ยนเป็นชื่อผู้ใช้ + ทางออกจากระบบ (เมนูย่อยแบบจอใหญ่
                ใช้บนจอเล็กไม่ได้ เพราะมันลอยทับเมนูพับที่กางอยู่พอดี) */}
            {profile ? (
              <>
                <div className="hm-nav__mobile-user">
                  <span className="hm-nav__user-avatar">{initials(profile.full_name || profile.email)}</span>
                  <div className="min-w-0">
                    <b>{profile.full_name || "-"}</b>
                    <span>{profile.email}</span>
                  </div>
                </div>
                <button
                  type="button"
                  className="hm-btn hm-btn--ghost hm-nav__mobile-login"
                  onClick={() => this.setState({ open: false, account: true })}
                >
                  <span className="hm-ico">{ICON.user}</span>
                  {t("partner_profile_title")}
                </button>
                {!!adminLink && (
                  <a className="hm-btn hm-btn--ghost hm-nav__mobile-login" href={adminLink}>
                    <span className="hm-ico">{ICON.grid}</span>
                    {t("home_go_admin")}
                  </a>
                )}
                <button type="button" className="hm-btn hm-btn--ghost hm-nav__mobile-login" onClick={this.Logout}>
                  <span className="hm-ico">{ICON.logout}</span>
                  {t("logout")}
                </button>
              </>
            ) : (
              <button type="button" className="hm-btn hm-btn--primary hm-nav__mobile-login" onClick={this.openLogin}>
                <span className="hm-ico">{ICON.user}</span>
                {t("sign_in")}
              </button>
            )}
          </div>
        </div>
      </header>

      <HomeLoginModal open={login} onClose={this.closeLogin} onPartner={onPartner} onForgot={onForgot} />
      <HomeProfileModal open={account} onClose={() => this.setState({ account: false })} />
      </>
    );
  }
}

export default withRouter(HomeNavbar);
